import React from "react";

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom";

import logoNoText from '../../../../assets/img/ls_logo_print_square.png';

const DatumLogoSquare = () => {
    const renderTooltip = (messageTooltip: String) => {
        return (
            <Tooltip id="button-tooltip">
                {messageTooltip}
            </Tooltip>
        );
    }

    return (
        <div className="d-flex justify-content-around nav navbar-logo-parent" style={{ backgroundColor: "white", padding: "2.5px" }}>
            <OverlayTrigger placement="right" delay={{ show: 100, hide: 200 }} overlay={renderTooltip("Visit LandScan")}>
                <Link to="https://landscan.ai/">
                        <img
                            src={logoNoText}
                            width="32px"
                            className="d-inline-block align-middle logo-padding"
                            alt={"LandScan"}
                        />
                </Link> 
            </OverlayTrigger>
        </div>
    );
}

export default DatumLogoSquare;